import React, { useState } from 'react';
import { Icons } from '@ohif/ui-next';
import Button from './Button';
import { authService } from '../auth/authService';
import '../../custom/theme/index.css';

/**
 * Unauthorized component
 * Displays an "Unauthorized" message for patients trying to access restricted routes
 */
const Unauthorized: React.FC = () => {
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const handleLogout = async () => {
    setIsLoggingOut(true);
    try {
      await authService.logout({ scope: 'patient' });
      window.location.href = '/login';
    } catch {
      authService.clearPatientAuth();
      window.location.href = '/login';
    }
  };

  return (
    <div
      className="container-center"
      style={{
        backgroundColor: 'var(--bg-primary)',
        minHeight: '100vh',
      }}
    >
      <div
        className="card"
        style={{ maxWidth: '500px', textAlign: 'center' }}
      >
        {/* Logo */}
        <div className="mb-xl flex justify-center">
          <Icons.IQLineLogo />
        </div>

        {/* Unauthorized Message */}
        <div className="mb-lg">
          <h1
            className="heading mb-md"
            style={{ color: 'var(--text-primary)' }}
          >
            Not Authorized
          </h1>
          <p style={{ color: 'var(--text-secondary)', fontSize: '1rem' }}>
            You do not have permission to access this page.
          </p>
          <p
            className="mt-md"
            style={{ color: 'var(--text-secondary)', fontSize: '0.875rem' }}
          >
            If you are trying to access RIS, please log out of your patient session first.
          </p>
        </div>

        <Button
          variant="primary"
          onClick={handleLogout}
          isLoading={isLoggingOut}
          disabled={isLoggingOut}
        >
          Log out
        </Button>
      </div>
    </div>
  );
};

export default Unauthorized;
